module.exports = __webpack_public_path__ + "img/h-page4-48.7518c39b.png";